import { render, staticRenderFns } from "./medicina-ocupacional.vue?vue&type=template&id=b9b8f13c&"
import script from "./medicina-ocupacional.vue?vue&type=script&lang=js&"
export * from "./medicina-ocupacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports